/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAddChip = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M7 4h2V2h2v2h2V2h2v2h2V2h2v2h1v1h2v2h-2v2h2v2h-2v2h2v1h-4V6H6v12h8v4h-1v-2h-2v2H9v-2H7v2H5v-2H4v-1H2v-2h2v-2H2v-2h2v-2H2V9h2V7H2V5h2V4h1V2h2z" />
        <path d="M20 18h2v2h-2v2h-2v-2h-2v-2h2v-2h2zm-4-2H8V8h8zm-6-2h4v-4h-4z" />
      </g>
    </g>
  </Icon>
);
export { SvgAddChip as AddChip };
